import { Flex, Box, Container } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardWrapper from "../../Auth/AuthWrapper";
import {
  ASSISTANT_PATHS,
  isAssistantAllowedPath,
  isAssistantRole,
} from "../../../helpers/assistantAccess";
import SuperAdminSidenavbar from "../sideNavbars/superAdminSidenavbar";
import TeacherSidenavbar from "../sideNavbars/teacherSidenavbar";
import AssistantSidenavbar from "../sideNavbars/assistantSidenavbar";
import MobileSidebar from "../sideNavbars/mobile-sidebar";
const Layout = ({ children }) => {
  const userData = useSelector((state) => state.user.userData);
  const roleName = userData?.role?.[0]?.name;
  const location = useLocation();
  const navigate = useNavigate();

  const blockAssistant =
    isAssistantRole(roleName) && !isAssistantAllowedPath(location.pathname);

  useEffect(() => {
    if (blockAssistant) {
      navigate(ASSISTANT_PATHS.students, { replace: true });
    }
  }, [blockAssistant, navigate]);

  return (
    <DashboardWrapper roles={["Admin", "Super Admin", "Teacher", "Assistant"]}>
      <Flex w="100%" h="100%" dir="rtl">
        <Box w={{ base: "20%" }} display={{ base: "none", md: "block" }}>
          {userData?.role?.length > 0 ? (
            isAssistantRole(roleName) ? (
              <AssistantSidenavbar />
            ) : roleName == "Teacher" ? (
              <TeacherSidenavbar />
            ) : (
              <SuperAdminSidenavbar />
            )
          ) : null}
        </Box>
        <MobileSidebar />
        <Container h="100%" maxW="container.xl" w={{ base: "100%", lg: "80%" }}>
          <Box w="100%" h="100%" overflowX="auto" overflowY="visible">
            {blockAssistant ? null : children}
          </Box>
        </Container>
      </Flex>
    </DashboardWrapper>
  );
};

export default Layout;
